export const PUBLIC_URL_PATHS: string[] = ['/token/login', '/token/refresh'];
